var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.2,
    cx: 24,
    cy: 24,
    r: 24,
    fill: "#00A27D"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40 17.752L24 27.0852L8 17.752V33.3312C8 34.7976 9.2004 35.998 10.6668 35.998H37.3332C38.7996 35.998 40 34.7976 40 33.3312V17.752Z",
    fill: "#00A27D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 14.6668L24 24L40 14.6668C40 13.2004 38.7996 12 37.3332 12H10.6668C9.2004 12 8 13.2004 8 14.6668Z",
    fill: "#00A27D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.e94cb8eb6edd78587514d3bdd974f222.svg";
export { ForwardRef as ReactComponent };